import React from 'react';
import { Form, FormRenderProps } from 'react-final-form';
import { Box, Grid, Stack } from '@mui/material';

import { Button, Typography, LazyAutocompleteFieldNotMultiple } from '@occc/ui-design-system';
import { KeyboardDatePicker } from '@occc-app/design-system';
import { useGetOpenCommerceUsersLazy } from '@occc-app/dataAccessLayer/openCommerceUser/queries';

import {
  renderUserSelectOption,
  mapUserRawResponseItemToAutocompleteOption,
  mapUsersQueryResponseToRawArray,
  makeQueryOpenCommerceUserFilter,
} from './comments-filter-form.utils';
import {
  CommentsFilterFormValues,
  CommentsFilterFormAuthorValues,
  CommentsFilterFormProps,
} from './comments-filter-form.type';

export const CommentsFilterForm = (props: CommentsFilterFormProps) => {
  const { onSubmit, onReset, initialValues } = props;

  const renderForm: FormRenderProps<CommentsFilterFormValues>['render'] = React.useCallback(
    ({ handleSubmit, form, values }: FormRenderProps<CommentsFilterFormValues>) => {
      const reset = () => {
        form.reset();
        onReset();
      };

      return (
        <Stack component='form' onSubmit={handleSubmit} spacing={2} p={3}>
          <Typography variant='h6' paragraph>
            Filter comments
          </Typography>
          <LazyAutocompleteFieldNotMultiple<
            CommentsFilterFormAuthorValues,
            ReturnType<typeof useGetOpenCommerceUsersLazy>['response']
          >
            label='Comment by'
            name='author'
            placeholder='Start typing to select user'
            renderOption={renderUserSelectOption}
            useLazyQuery={useGetOpenCommerceUsersLazy}
            makeQueryFilter={makeQueryOpenCommerceUserFilter}
            mapQueryResponseToRawArray={mapUsersQueryResponseToRawArray}
            mapRawResponseItemToAutocompleteOption={mapUserRawResponseItemToAutocompleteOption}
          />
          <Box>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <KeyboardDatePicker
                  label='Start Date'
                  name='startDate'
                  maxDate={values?.endDate || undefined}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <KeyboardDatePicker
                  label='End Date'
                  name='endDate'
                  minDate={values?.startDate || undefined}
                />
              </Grid>
            </Grid>
          </Box>
          <Stack spacing={2} direction='row' justifyContent='flex-end'>
            <Button color='primary' onClick={reset}>
              Reset
            </Button>
            <Button type='submit' color='primary' variant='contained'>
              Apply
            </Button>
          </Stack>
        </Stack>
      );
    },
    [onReset],
  );
  return (
    <Form<CommentsFilterFormValues>
      onSubmit={onSubmit}
      render={renderForm}
      initialValues={initialValues}
    />
  );
};
